import React, { createContext, useContext, useState, useEffect } from 'react';
import useUserRole from '../hooks/useUserRole';

const AdminContext = createContext();

export const useAdmin = () => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error('useAdmin must be used within an AdminProvider');
    }
    return context;
};

export const AdminProvider = ({ children }) => {
    const { userRole, loading } = useUserRole();
    const [isAdminMode, setIsAdminMode] = useState(false);

    // Efecto para manejar el estado de admin
    useEffect(() => {
        if (!loading) {
            const savedAdminMode = localStorage.getItem('adminMode');
            if (userRole === 'ADMIN_ROLE') {
                // Si es la primera vez o había estado en modo admin, mantener en modo admin
                if (savedAdminMode === null || savedAdminMode === 'true') {
                    setIsAdminMode(true);
                    localStorage.setItem('adminMode', 'true');
                } else {
                    setIsAdminMode(false);
                }
            } else {
                // Si no es admin, asegurarse de que no esté en modo admin
                setIsAdminMode(false);
                localStorage.removeItem('adminMode');
            }
        }
    }, [userRole, loading]);

    const toggleAdminMode = () => {
        if (userRole === 'ADMIN_ROLE') {
            const newMode = !isAdminMode;
            setIsAdminMode(newMode);
            localStorage.setItem('adminMode', newMode.toString());
        }
    };

    const isAdmin = userRole === 'ADMIN_ROLE';

    const value = {
        isAdmin,
        isAdminMode,
        toggleAdminMode,
        loading
    };

    return (
        <AdminContext.Provider value={value}>
            {children}
        </AdminContext.Provider>
    );
};
